import React from 'react';
import classNames from 'classnames';
import EllipsisTooltip from '../EllipsisTooltip';
import useStyles from './style';
import { useTiledDirectory } from './hooks/useTiledDirectory';
import { TiledDirectoryTitle } from './components/TiledDirectoryTitle';
import type { DirectoryData, TiledDirectoryProps } from './typing.d.ts';

/**
 * @description 平铺目录组件
 */
const TiledDirectory: React.FC<TiledDirectoryProps> = (props) => {
    const { styles } = useStyles();
    const { data, isExpanded, toggleExpand } = useTiledDirectory(props.data, props.isExpanded);

    /** 修改激活的标题 */
    const onChangeTitleDirectory = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        if (data) {
            props.onChangeTitle(data.CategoryId);
        }
    }, [data, props.onChangeTitle]);

    /** 修改激活的选项 */
    const onChangeItemDirectory = React.useCallback((e: React.MouseEvent<HTMLDivElement>, value: number) => {
        e.stopPropagation();
        e.preventDefault();
        if (data) {
            props.onChangeItem(data.CategoryId, value);
        }
    }, [data, props.onChangeItem]);

    /** 切换展开状态 */
    const handleExpandChange = React.useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
        e.stopPropagation();
        // 先切换内部状态
        toggleExpand();
        // 通知外部状态变化
        if (data && props.onExpandChange) {
            props.onExpandChange(!isExpanded, data.CategoryId);
        }
    }, [data, isExpanded, toggleExpand, props.onExpandChange]);

    if (!data) {
        return null;
    }

    return (
        <div>
            <TiledDirectoryTitle
                data={data}
                isExpanded={isExpanded}
                onToggle={handleExpandChange}
                onTitleClick={onChangeTitleDirectory}
                selectedTitle={props.selectedTitle}
            />
            {/* 三级目录 */}
            {isExpanded && data.SubList && data.SubList.length > 0 && (
                <div className={styles.categoryListBox}>
                    {data.SubList.map((child: DirectoryData) => (
                        <div
                            key={child.CategoryId}
                            className={
                                classNames(styles.categoryItemDefault, {
                                    [styles.categoryItemHover]: props.selectedItem !== child.CategoryId,
                                    [styles.categoryItemActive]: props.isActive && props.selectedItem === child.CategoryId
                                })
                            }
                            onClick={(e) => onChangeItemDirectory(e, child.CategoryId)}
                        >
                            <EllipsisTooltip text={child.CategoryName} containerLength={props.containerWidth} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TiledDirectory;